module.exports = __webpack_public_path__ + "static/media/wsp_2023.991512ab.png";